import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "icon"];
import React from 'react';
import { IconWrapper, LabelWrapper, FilterColLabelText } from '../filter-item/filter-item.styled';
export var FilterShowMoreItem = function FilterShowMoreItem(_ref) {
  var label = _ref.label,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(LabelWrapper, rest, icon && /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement(FilterColLabelText, null, label));
};